if (!customElements.get("accordion-wrapper")) {
  class Accordion extends HTMLElement {
    constructor() {
      super();
      this.el = this,
      this.options = this.dataset.options;
      this.multipleActive = this.dataset.multipleActive || false;
      this.defaultOpen = this.dataset.defaultOpen || false;
      this.items = this.querySelectorAll(".accordion__item");
    }

    connectedCallback() {
      this.bindEvents();
      this.addEventListener('content-refreshed', this.refresh.bind(this));
    }

    bindEvents() {    
      this.items.forEach((e) => {
        this.bindToggleEvent(e);
        if(e.dataset.open || this.defaultOpen) {
          const content = e.querySelector(".accordion__content");
          e.classList.add("is-active");
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
      if(this.defaultOpen) {
        this.classList.add('mobile-facets__initialized');
      }
    }

    bindToggleEvent(e) {
      const toggle = e.querySelector(".accordion__toggle");
      if(toggle){
        toggle.addEventListener("click", (o) => {
          o.preventDefault();
          this.toggle(e.dataset.item);
        });
      }
    }
    
    refresh() {
      this.items = this.querySelectorAll(".accordion__item");
      this.items.forEach((e) => {
        this.bindToggleEvent(e);
        if(e.classList.contains('is-active')) {
          const content = e.querySelector(".accordion__content");
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }

    toggle(t) {
      const multipleActive = this.multipleActive;
      this.items.forEach((e) => {
        const content = e.querySelector(".accordion__content");
        if(e.dataset.item == t && !e.classList.contains('is-active')) {
          e.classList.add("is-active");
          content.style.maxHeight = content.scrollHeight + "px";
        } else if(e.dataset.item == t && e.classList.contains('is-active')) {
          e.classList.remove("is-active");
          content.style.maxHeight = null;
        } else if(!multipleActive) {
          e.classList.remove("is-active");
          content.style.maxHeight = null;
        }
      });
    }
  }

  customElements.define('accordion-wrapper', Accordion);
}